import { Formik, Form, Field, ErrorMessage } from "formik";
import swal from "sweetalert";
import { getIntouch } from "../../../api.services.js/others";
import { getInTouchValidationSchema } from "./constants";

const ContactForm = ({ close, goBack }) => {
  const submitGetInTouch = async (values, { setSubmitting }) => {
    try {
      let response = await getIntouch({
        name: values.name,
        phone: values.phone,
        pincode: values.pincode,
        email: values.email,
        call_id: "",
      });

      close();
      if (response?.message) {
        localStorage.setItem("leadfilled", "true");
        swal(response?.message);
      } else {
        swal(response.data.get_in_touch.msg);
        localStorage.setItem("TarikClosed", "true");
      }
    } catch (error) {
      console.log("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ name: "", phone: "", pincode: "", email: "" }}
      validationSchema={getInTouchValidationSchema}
      onSubmit={submitGetInTouch}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="form-group">
            <label>Name:</label>
            <Field type="text" name="name" />
            <ErrorMessage name="name" component="div" className="error" />
          </div>

          <div className="form-group">
            <label>Phone Number:</label>
            <Field type="text" name="phone" />
            <ErrorMessage name="phone" component="div" className="error" />
          </div>

          <div className="form-group">
            <label>Pincode:</label>
            <Field type="text" name="pincode" />
            <ErrorMessage name="pincode" component="div" className="error" />
          </div>

          <div className="form-group">
            <label>Email:</label>
            <Field type="email" name="email" />
            <ErrorMessage name="email" component="div" className="error" />
          </div>

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default ContactForm;
